import React from "react";
import { useTranslation } from "react-i18next";
import { Body1 } from "@activecollab/components";
import PropTypes from "prop-types";
import ChildTasksContainer from "./ChildTasksContainer.jsx";
import DependenciesBodyTemplate from "./DependenciesBodyTemplate.jsx";
import DependencyFormContainer from "./DependencyFormContainer.jsx";
import ParentTasksContainer from "./ParentTasksContainer.jsx";

const DependenciesBodyWithItems = ({ taskId, onClick, onCancel, taskHasDependencies, force }) => {
  const { t } = useTranslation();

  return (
    <DependenciesBodyTemplate>
      <div className="object_subtasks_inner">
        {!taskHasDependencies ? (
          <Body1
            weight="bold"
            className="tw-mb-2"
          >
            {t("Dependencies")}
          </Body1>
        ) : null}
        <ParentTasksContainer
          taskHasDependencies={taskHasDependencies}
          taskId={taskId}
        />
        <ChildTasksContainer
          taskHasDependencies={taskHasDependencies}
          taskId={taskId}
          showConflict
        />
        <div className="object_subtasks_open task_dependencies_form">
          <DependencyFormContainer
            force={force}
            taskId={taskId}
            handleTriggerClick={onClick}
            handleCancel={onCancel}
          />
        </div>
      </div>
    </DependenciesBodyTemplate>
  );
};

DependenciesBodyWithItems.propTypes = {
  taskId: PropTypes.number,
  onCancel: PropTypes.func,
  onClick: PropTypes.func,
  taskHasDependencies: PropTypes.bool,
  force: PropTypes.bool,
};

DependenciesBodyWithItems.defaultProps = {
  taskHasDependencies: false,
  force: false,
};

DependenciesBodyWithItems.displayName = `DependenciesBodyWithItems`;

export default DependenciesBodyWithItems;
